import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Component, Input, Inject, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CreateAuthenticatorPinRequestAction, ResetPasswordWithAuthenticatorAction, UnRegisterAuthenticatorAction, UnlockAccountWithAuthenticatorAction } from '@ngxs-store/auth-store/auth.actions';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-two-fa-dialog',
  templateUrl: './two-fa-dialog.html',
})
export class TwoFaDialogComponent  implements OnDestroy {
    @Input() isLoading: boolean;
    @Input() isMobileMode: boolean;
    @Output() requestForgotenPasswordClicked = new EventEmitter<{ username: string }>();

    form: FormGroup;
    username: string;
    type: string;
    key: string;
    private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<TwoFaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private store: Store) {
        this.username = data.username;
        this.type = data.type;
        this.form = this.formBuilder.group({
            code: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        this.store.dispatch(new CreateAuthenticatorPinRequestAction({ username: this.username }))
        .subscribe(() => {
            const state = this.store.selectSnapshot(AuthState);
            this.key = state.pinRequestModel.key;
        });
    }

    onCancelClick(): void {
        this.dialogRef.close() ;
    }


    addClick() {
        // Submit the 2FA code for verification
        const pin = this.form.value.code;
        if(this.type === "login") {
            this.store.dispatch(new UnlockAccountWithAuthenticatorAction({ pin, key: this.key })).pipe(
                tap(() => {
                    this.dialogRef.close();
                }),
                takeUntil(this.unsubscribe$)
            ).subscribe();
        }else{
            this.store.dispatch(new ResetPasswordWithAuthenticatorAction({ pin, key: this.key })).pipe(
                tap(() => {
                    this.dialogRef.close(true);
                }),
                takeUntil(this.unsubscribe$)
            ).subscribe();
        }
    }

    unRegisterClick(){
        this.store.dispatch(new UnRegisterAuthenticatorAction({username: this.username}));
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
